import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  FormAlertModule,
  RadioButtonModule
} from '@com-delta-idp/mnx-ui-kit';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LogoHeaderModule } from '../../shared/logo-header/logo-header.module';
import { RecoveryOptionsComponent } from './recovery-options.component';

@NgModule({
  declarations: [RecoveryOptionsComponent],
  imports: [
    CommonModule,
    LogoHeaderModule,
    LoginHeaderModule,
    ButtonModule,
    ReactiveFormsModule,
    RadioButtonModule,
    FormAlertModule
  ],
  exports: [RecoveryOptionsComponent]
})
export class RecoveryOptionsModule {}
